import * as _4 from 'lodash4';
import { IExternalActionTimeSlot } from 'ui-ng-calendar';
import { ITermProgramInfoModel, TermProgramInfoModel } from '../../../term_courses/models/term_program_info_model';
import { ICommand, IQuery } from 'core-ts-types';
import { OpenModalFlag } from '../../../course_scheduler/components/calendar_placeholder_alert/openModalFlag';
import { CalendarTimesQuery } from '../../queries/calendar_times_query';
import { CalendarSwapTimesQuery } from '../../queries/calendar_swap_times_query';
import { TermCourseQuery } from '../../../term_courses/queries/term_courses_query';
import { SectionSwapServant } from '../../../../swap/servants/section_swap_servant';
import { ITermSessionsDatasource } from '../../../term_courses/datasources/term_sessions_datasource';
import { ITermSession } from '../../../../interfaces/scheduler_interfaces';
import { TimelineQuery } from '../../../../components/timeline/queries/timeline_query';
import { ScheduledSectionsQuery } from '../../../course_scheduler/queries/scheduled_sections_query';
import { SectionInfoServant } from '../../../sections/servants/section_info_servant';

interface ICalendarTransaction {
  transaction: IExternalActionTimeSlot;
}
class SchedulerCalendar {
  private termAndProgramInfo: ITermProgramInfoModel;
  private termId: number;
  private query: IQuery;
  private timelineQuery: IQuery;
  private timeSliceQuery: IQuery;
  private isPreferencesModeActive: boolean = false;
  private showCalendarOutline: boolean = false;
  private closeCalendarPlaceHolderAlert: boolean = true;
  private manualShowCalendarPlaceholder: boolean = false;
  private isInSwapMode: boolean = false;
  private mode: string = '';
  private timeSlices: IQuery;
  constructor(
    private $state: ng.ui.IStateService,
    private $stateParams: ng.ui.IStateParamsService,
    private $timeout: ng.ITimeoutService,
    private ngTermProgramInfoModel: TermProgramInfoModel,
    private saveStudentUnavailabilityCommand: ICommand,
    private deleteStudentUnavailabilityCommand: ICommand,
    private phxFocusDelegate: any,
    private schedulePreferencesExternal: any,
    private preferencesBusyTimes: any,
    private ngOpenModalFlag: OpenModalFlag,
    private ngCalendarTimesQuery: CalendarTimesQuery,
    private ngCalendarSwapTimesQuery: CalendarSwapTimesQuery,
    private ngTimelineQuery: TimelineQuery,
    private ngTermCourseQuery: TermCourseQuery,
    private ngSectionSwapServant: SectionSwapServant,
    private ngSectionInfoServant: SectionInfoServant,
    private ngTimeSliceQuery: IQuery,
    private calendarPreviewDragEnd: any,
    private ngScheduledSectionsQuery: ScheduledSectionsQuery
  ) {}

  $onInit() {
    this.termAndProgramInfo = this.ngTermProgramInfoModel.read();
    this.isPreferencesModeActive = _4.includes(_4.get(this.$state, 'current.url', ''), 'preferences');
    this.termId = this.$stateParams.termId;
    this.closeCalendarPlaceHolderAlert = false;
    this.hideCalendarOutline();
    this.isInSwapMode = this.ngSectionSwapServant.isInSwapMode();
    this.query = this.mode === 'swap' ? this.ngCalendarSwapTimesQuery : this.ngCalendarTimesQuery;
    this.timelineQuery = this.ngTimelineQuery;
    this.timeSliceQuery = this.ngTimeSliceQuery;
  }

  activateCalendarOutline() {
    this.showCalendarOutline = true;
  }

  hideCalendarOutline() {
    this.showCalendarOutline = false;
    this.calendarPreviewDragEnd();
  }

  enterPreferencesMode() {
    this.schedulePreferencesExternal.openPreferences();
    this.$timeout(() => this.phxFocusDelegate.focus('preferences-description'), 500);
  }

  getBusyTimesSummary() {
    this.preferencesBusyTimes.getSummary();
  }

  saveCalendarTime({ transaction }: ICalendarTransaction) {
    return this.saveStudentUnavailabilityCommand(this.termId, transaction.save).finally(() => {
      this.getBusyTimesSummary();
    });
  }

  deleteCalendarTime({ transaction }: ICalendarTransaction) {
    return this.deleteStudentUnavailabilityCommand(this.termId, transaction.id).finally(() => {
      this.getBusyTimesSummary();
    });
  }

  editCalendarTime({ transaction }: ICalendarTransaction) {
    return this.deleteStudentUnavailabilityCommand(this.termId, transaction.id).then(() =>
      this.saveCalendarTime({ transaction })
    );
  }

  viewPreferences() {
    this.enterPreferencesMode();
  }

  allCoursesSelected() {
    return this.ngTermCourseQuery.result.unscheduled.length === 0;
  }

  shouldShowCalendarPlaceHolderAlert() {
    const validPlaceholderStates = !_4.some(
      ['my.schedule.registration.suggestions', 'my.routeModal.courseDetails'],
      (currentState) => this.$state.is(currentState)
    );
    if (this.manualShowCalendarPlaceholder) {
      return true;
    }
    return (
      _4.isEmpty(this.ngCalendarTimesQuery.result.times) &&
      validPlaceholderStates &&
      !this.closeCalendarPlaceHolderAlert &&
      !this.ngOpenModalFlag.isModalOpen()
    );
  }

  showInstructionDialog() {
    this.manualShowCalendarPlaceholder = true;
  }

  hidePlaceHolder() {
    this.manualShowCalendarPlaceholder = false;
    this.closeCalendarPlaceHolderAlert = true;
  }
}
class SchedulerCalendarComponent implements ng.IComponentOptions {
  public bindings: any;
  public controller: any;
  public templateUrl: string;
  constructor() {
    this.controller = SchedulerCalendar;
    this.templateUrl = 'capability-ng-scheduler/src/views/calendar/components/calendar/calendar.html';
    this.bindings = {
      mode: '@'
    };
  }
}
angular.module('capability-ng-scheduler').component('schedulerCalendar', new SchedulerCalendarComponent());



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/calendar/components/calendar/calendar.ts